// extracted by mini-css-extract-plugin
export default {"secondLabel":"OzEownOlWo77VIlJmK6I","checked":"v_DxF3I2jEuxrKWt2hje"};